import types from './types';

const initialState = {
  byKey: {},
  keys: [],
  loading: false,
  loaded: false,
};

const upsert = (state, integration) => ({
  ...state,
  byKey: { ...state.byKey, [integration.key]: integration },
  keys: state.keys.includes(integration.key) ? state.keys : [...state.keys, integration.key],
});

const integrations = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.getAll:
      return { ...state, loading: true };

    case types.getAllSuccess: {
      // request() unwraps `data` so the saga receives the list directly.
      const list = Array.isArray(payload) ? payload : (payload?.data ?? []);
      const byKey = Object.fromEntries(list.map(i => [i.key, i]));
      const keys = list.map(i => i.key);
      return { ...state, byKey, keys, loading: false, loaded: true };
    }

    case types.getAllFailure:
      return { ...state, loading: false };

    case types.updateSuccess:
    case types.syncSuccess:
      // request() unwraps `data` so the saga receives the row directly.
      return upsert(state, payload);

    default:
      return state;
  }
};

export default { integrations };
